import { render, staticRenderFns } from "./CreateScheduledMessage.vue?vue&type=template&id=6ad328ba&scoped=true&"
import script from "./CreateScheduledMessage.vue?vue&type=script&lang=js&"
export * from "./CreateScheduledMessage.vue?vue&type=script&lang=js&"
import style0 from "./CreateScheduledMessage.vue?vue&type=style&index=0&id=6ad328ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad328ba",
  null
  
)

export default component.exports